import { useTranslation } from "react-i18next"
import Section from "components/layout/section"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import PageTitle from "features/navigation/pageTitle"
import RightSidebar from "@/components/sidebar/right/RightSidebar"
import AccessInvitationList from "@/components/access/AccessInvitationList"
import IconButton from "@/components/buttons/iconButton"
import { ReactComponent as RefreshIcon } from 'assets/icons/refresh.svg'
import useAccess from "@/hooks/useAccess"
import { FormStatus } from "@/types"
import { useNavigate, useParams } from "react-router-dom"
import useStorages from "@/hooks/useStorages"
import { MainSheetHeaderActions } from "@/components/layout/layoutChrome"

const AccessInvitationsPage = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()

    const {
        storageId
    } = useParams<{ storageId: string }>()

    const {
        reloadAccessDocs,
        userInvitationsStatus
    } = useAccess({ refetchInterval: 30_000 })

    const {
        storage,
        storageStatus
    } = useStorages({ storageId })

    return (
        <>
            <PageTitle title={t('titleAccessInvitations')} />
            <MainSheetHeaderActions>
                <IconButton
                    icon={<RefreshIcon className={userInvitationsStatus === FormStatus.LOADING ? 'animate-spin' : ''} />}
                    onClick={reloadAccessDocs}
                    disabled={userInvitationsStatus === FormStatus.LOADING}
                />
            </MainSheetHeaderActions>
            <Section padX={false}>
                <AccessInvitationList />
            </Section>
            <RightSidebar />
        </>
    )
}

export default AccessInvitationsPage

